<template>
  <div class="solution-page">

    <!-- 第一部分：顶部大图 -->
    <section class="hero-section">
      <img src="@/assets/solutions/hero.png" alt="展示图" class="hero-image" />
    </section>

    <!-- 第二部分：标题和介绍文字 -->
    <section class="text-section content-wrapper">
      <h2 class="section-title">技术实力</h2>
      <p class="section-description">我们汇聚经验丰富的技术团队，掌握前沿开发理念与工具，致力于构建可靠、高效、可扩展的技术解决方案。</p>
    </section>

    <!-- 第三部分：3行2列图片展示 -->
    <section class="gallery-section content-wrapper">
      <h2 class="section-title">我们拥有</h2>
      <div class="card-grid">
        <div v-for="(img, index) in galleryImages" :key="index" class="card">
          <img :src="img" class="card-image" />
        </div>
      </div>
    </section>

    <!-- 第四部分：标题和介绍文字 -->
    <section class="text-section content-wrapper">
      <h2 class="section-title">解决方案</h2>
      <p class="section-description">我们针对不同行业需求与技术挑战，提供定制化的落地解决方案。</p>
    </section>

    <!-- 第五部分：图文并排展示 -->
    <section class="split-section content-wrapper" ref="splitSection">
      <div class="split-image">
        <img
          ref="splitImage"
          src="@/assets/solutions/left-show.png"
          alt="图文展示"
          @load="adjustGap"
        />
      </div>
      <div class="split-content" ref="splitContent">
        <div v-for="(item, index) in infoList" :key="index" class="info-block">
          <h3 class="info-title">{{ item.title }}</h3>
          <p class="info-description">{{ item.description }}</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      galleryImages: [
        require('@/assets/solutions/full-stack.png'),
        require('@/assets/solutions/multi-platform.png'),
        require('@/assets/solutions/pay.png'),
        require('@/assets/solutions/cloud.png'),
        require('@/assets/solutions/safe.png'),
        require('@/assets/solutions/performance.png')
      ],
      infoList: [
        { title: '移动业务增长方案：', description: '定制高性能App/小程序，连接用户，驱动增长。' },
        { title: 'Web平台构建方案：', description: '开发定制化Web应用/企业系统，实现业务在线化与自动化。' },
        { title: '专属软件开发方案：', description: '量身打造高效、稳定软件，解决特定业务痛点。' },
        { title: '生态融合方案 (小程序)：', description: '开发轻量小程序，高效利用平台流量与服务。' },
        { title: '技术价值转化方案：', description: '提供技术转让对接与交流平台，释放技术潜能。' },
        { title: '技术升级与咨询方案：', description: '提供专业咨询，明晰技术路径，优化投资回报。' }
      ]
    }
  },
  mounted() {
    this.adjustGap()
    window.addEventListener('resize', this.adjustGap)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.adjustGap)
  },
  methods: {
    adjustGap() {
      this.$nextTick(() => {
        const imgEl = this.$refs.splitImage
        const contentEl = this.$refs.splitContent
        if (!imgEl || !contentEl) return

        const imgHeight = imgEl.clientHeight
        const blocks = contentEl.children.length

        let blocksHeight = 0
        for (let child of contentEl.children) {
          blocksHeight += child.offsetHeight
        }

        let gap = (imgHeight - blocksHeight) / (blocks - 0.1)
        if (gap < 0) gap = 0

        contentEl.style.gap = gap + 'px'
      })
    }
  }
}
</script>

<style scoped>
.solution-page {
  font-family: sans-serif;
  min-height: 150vh;
}

/* 全宽顶部图像 */
.hero-section {
  width: 100%;
  overflow: hidden;
}
.hero-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 限制80%宽度容器居中 */
.content-wrapper {
  max-width: 65%;
  margin: 0 auto;
}

/* 第二 & 第四部分：文字区域 */
.text-section {
  text-align: center;
  padding: 40px 0;
}
.section-title {
  color: black;
  font-size: clamp(28px, 5vw, 35px);
  font-weight: bold;
  margin-bottom: 1.5rem;
}
.section-description {
  margin-top: 20px;
  font-size: 20px;
}

/* 第三部分：3行2列图片展示 */
.gallery-section {
  padding: 20px 0;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 50px;
}
.card {
  background-color: #f5f5f5;
  border-radius: 10px;
  overflow: hidden;
}
.card-image {
  width: 100%;
  display: block;
  border-radius: 10px;
}

/* 第五部分：左右图文 */
.split-section {
  display: flex;
  flex-wrap: wrap;
  padding: 40px 0;
  gap: 20px;
  transform: 10%;
}
.split-image {
  flex: 1;
  min-width: 300px;
  margin-right: 100px;
}
.split-image img {
  width: 100%;
  border-radius: 10px;
}
.split-content {
  flex: 2;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  /* 初始gap，JS会动态覆盖 */
  gap: 120px;
}

.info-block {
  background-color: transparent;
  padding: 0;
  border-radius: 0;
}
.info-title {
  font-size: 32px;
  font-weight: bold;
  color: #1664FF;
  margin-bottom: 30px;
}
.info-description {
  font-size: 20px;
}
</style>
